import { Link } from 'react-router-dom';

interface ComicCardFeaturedProps {
  id: string;
  title: string;
  description: string;
  coverImage: string;
  rating: number;
  chapters: number;
  status: string;
}

export default function ComicCardFeatured({
  id,
  title,
  description,
  coverImage,
  rating,
  chapters,
  status,
}: ComicCardFeaturedProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
      data-product-shop
    >
      <img
        src={coverImage}
        alt={title}
        title={`${title} - 韩漫免费看`}
        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs text-accent-400 font-semibold bg-accent-500/30 px-1.5 py-0.5 rounded">
            ★ {rating}
          </span>
          <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
            status === '连载中' ? 'bg-primary-500/80 text-background-50' : 'bg-foreground-500/60 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <h3 className="text-base md:text-lg font-bold text-background-50 font-heading mb-1">
          {title}
        </h3>
        <p className="text-xs text-background-200/80 line-clamp-2 leading-relaxed">
          {description}
        </p>
        <p className="text-xs text-background-300 mt-2">
          共{chapters}话
        </p>
      </div>
    </Link>
  );
}